<template> 
    <div class="tab-pane fade show active" id="JourneyPlanner" role="tabpanel" aria-labelledby="journeyplanner-tab">
        <div class="h3 mb-3 text-white d-none d-md-inline-block">Hvor skal du?</div>
        <div class="h3 mb-3 text-white d-block d-md-none">Reiseplanlegger</div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="inputlocationFrom" class="text-white">Fra</label>
                    <typeahead
                        source="/Umbraco/Api/BusStopLookupAPI/BusStopLookupFarte?prefixText="
                        placeholder="Søk på adresse, holdeplass eller sted"
                        filter-key="title"
                        :start-at="2"
                        id="locationFrom"
                    >
                    </typeahead>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="inputlocationTo" class="text-white">Til</label>
                    <typeahead
                        source="/Umbraco/Api/BusStopLookupAPI/BusStopLookupFarte?prefixText="
                        placeholder="Søk på adresse, holdeplass eller sted"
                        filter-key="title"
                        :start-at="3"
                        id="locationTo"
                    >
                    </typeahead>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="date" class="text-white">Dato</label>
                            <date-picker id="date" v-model="date" readonly="readonly" :config="dateOptions"></date-picker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="time" class="text-white">Klokken</label>
                            <date-picker id="time" v-model="time" readonly="readonly" :config="timeOptions"></date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="d-none d-md-block"><label><br /></label><br /></div>
                    <button type="button" class="btn btn-primary d-block d-md-inline float-md-end" v-on:click="searchResult()" title="Finn reise" aria-label="Finn reise">Finn reise</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import Typeahead from './Typeahead.vue'
    import moment from 'moment'
    export default {
        name: 'JourneyPlanner',
        data () {
            return {
                date: moment().format('DD.MM.YYYY'),
                dateOptions: {
                    ignoreReadonly: true,
                    allowInputToggle: true,
                    format: 'DD.MM.YYYY',
                    useCurrent: true,
                    minDate: moment().add(-1, 'd'),
                    maxDate: moment().add(365, 'd'),            
                    locale: moment.locale('nb'),
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-calendar-check',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times-circle'
                    }
                },
                time: moment().format('HH:mm'),
                timeOptions: {
                    ignoreReadonly: true,
                    allowInputToggle: true,
                    format: 'HH:mm',
                    useCurrent: true,
                    locale: moment.locale('nb'),
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-calendar-check',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times-circle'
                    }
                }
            }
        },
        components: { 
            Typeahead,
            datePicker
        },
        methods: {
            searchResult () {
                window.location.href = '/reise/reiseplanlegger?from=' + inputlocationFrom.value + '&to=' + inputlocationTo.value + '&date=' + this.date + '&time=' + this.time + '&direction=1';
            }
        }  
    }
</script>